<template>
  <va-create-layout>
    <route-form :title="title" :item="item"></route-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
